var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.data ? _c('div', {
    staticClass: "mgt_no"
  }, [_c('Icon', {
    staticClass: "icon",
    attrs: {
      "type": _vm.data.icon
    }
  }), _c('div', {
    staticClass: "text",
    style: _vm.data.style
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.data.content)
    }
  })]), _vm.data.button.visible && _vm.isAdmin ? _c('div', [_c('Button', {
    staticClass: "button",
    on: {
      "click": _vm.add
    }
  }, [_vm._v(_vm._s(_vm.data.button.text))])], 1) : _vm._e()], 1) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };